import { User } from 'types/auth'

export const constructSessionId = (user: User) =>
  btoa(user.id + new Date(Date.now()).toISOString())
